import React from "react";
import PropTypes from "prop-types";

const Subtotal = ({ style, className, lineItem, defaultPrice }) => {
  let priceDisplay;

  if (lineItem) {
    priceDisplay = (
      <React.Fragment>
        <div>{`$${lineItem.price}`}</div>
        {lineItem.quantityDiscount > 0 &&
          <div className="sub-txt" style={{ fontStyle: "italic", color: "var(--main-color)" }}>
            {`You saved $${lineItem.quantityDiscount * lineItem.quantity}!`}
          </div>
        }
      </React.Fragment>
    );
  }
  else {
    priceDisplay = <div style={{ color: "gray" }}>{`$${Math.round(defaultPrice)}`}</div>;
  }

  return (
    <div className={className} style={style}>
      <h4 className="text-dark header-txt">Subtotal</h4>
      {priceDisplay}
    </div>
  );
};

Subtotal.defaultProps = {
  style: null,
  className: "",
  lineItem: null
};

Subtotal.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  lineItem: PropTypes.object,
  defaultPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

export default Subtotal;